import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Radio,
  Avatar,
  Typography,
} from "@mui/material";

// Icons for different roles
import {
  Person,
  Agriculture,
  ShoppingCart,
  AccountBalance,
  ManageAccounts,
  Groups,
} from "@mui/icons-material";

const useStyles = makeStyles(() => ({
  roleCard: {
    marginBottom: "12px !important",
    borderRadius: "8px !important",
    transition: "all 0.2s ease !important",
  },
  selectedCard: {
    borderColor: "#1F5674 !important",
    backgroundColor: "rgba(31, 86, 116, 0.05) !important",
    boxShadow: "0 2px 12px rgba(31, 86, 116, 0.15) !important",
  },
  roleAvatar: {
    backgroundColor: "#1F5674 !important",
    width: "40px !important",
    height: "40px !important",
    marginRight: "16px !important",
  },
  roleName: {
    fontWeight: "500 !important",
    fontSize: "16px !important",
  },
  roleId: {
    fontSize: "12px !important",
    color: "#666 !important",
    marginTop: "4px !important",
  },
}));

// Function to get the appropriate icon based on role
export const getRoleIcon = (role) => {
  switch (role?.toUpperCase()) {
    case "FARMER":
      return <Agriculture />;
    case "BUYER":
      return <ShoppingCart />;
    case "FPO":
      return <Groups />;
    case "LENDER":
      return <AccountBalance />;
    case "PROGRAM_MANAGER":
      return <ManageAccounts />;
    default:
      return <Person />;
  }
};

const RoleCard = ({
  roleData,
  index,
  isSelected,
  isInteractive = true,
  onSelect,
}) => {
  const classes = useStyles();

  return (
    <Card
      key={index}
      variant="outlined"
      className={`${classes.roleCard} ${
        isSelected ? classes.selectedCard : ""
      }`}
    >
      <CardActionArea
        onClick={() => isInteractive && onSelect && onSelect(roleData)}
        disabled={!isInteractive}
      >
        <CardContent sx={{ padding: "16px" }}>
          <Grid container alignItems="center">
            <Grid item>
              <Avatar className={classes.roleAvatar}>
                {getRoleIcon(roleData.role)}
              </Avatar>
            </Grid>
            <Grid item xs>
              <Typography className={classes.roleName}>
                {roleData.role}
              </Typography>
              <Typography className={classes.roleId}>
                {roleData.custom_id}
              </Typography>
            </Grid>
            {isInteractive && (
              <Grid item>
                <Radio
                  checked={isSelected}
                  onChange={() => {
                    onSelect && onSelect(roleData);
                  }}
                  value={roleData.id}
                  name="role-selection"
                  color="primary"
                  inputProps={{ "aria-label": roleData.role }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default RoleCard;
